import * as React from 'react'
import { GoBackLinkConnected } from './GoBackLinkConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const GoBackLinkExamples = () => {
  return (
    <div className="GoBackLinkExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <GoBackLinkConnected />
      </Provider>
    </div>
  )
}
